import React from "react";
import { Table as AntdTable } from "antd";
import queryString from "query-string";
import { connect } from "react-redux";

import { push, concatReservedPush } from "ducks/router";
import numeral from "numeral";

type PaginatedTableProps = {
  callFetchingDataAsyncFunc: (params: any) => Promise<any>,
  search: string,
};

@connect(
  ({ router: { location } }) => {
    return { location };
  },
  null,
  null,
  { forwardRef: true }
)
class PaginatedTable extends React.Component<PaginatedTableProps> {
  static defaultProps = {
    search: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      loading: false,
      meta: {},
    };
    this._onChangePage = this._onChangePage.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    return {
      search: props.location.search,
    };
  }

  componentDidMount() {
    this._fetchData();
  }

  componentDidUpdate(_prevProps, prevState) {
    const { search } = this.state;
    if (search !== prevState.search) {
      this._fetchData();
    }
  }

  reload = () => {
    this._fetchData();
  };

  async _fetchData() {
    const { callFetchingDataAsyncFunc } = this.props;
    const { search } = this.state;
    if (!callFetchingDataAsyncFunc) {
      return;
    }
    try {
      this.setState({ loading: true });
      const params = queryString.parse(search.replace("?", ""));
      const res = await callFetchingDataAsyncFunc(params);

      this.setState({
        loading: false,
        items: res.items,
        meta: res.meta,
        total_revenue: res.total_revenue || undefined,
        total_NN_fee: res.total_NN_fee || undefined,
        total_other_fee: res.total_other_fee || undefined,
        total_khang_luat_fee: res.total_khang_luat_fee || undefined,
      });
    } catch (e) {
      console.log(e);
      this.setState({
        loading: false,
        items: [],
        meta: {},
      });
    }
  }

  _onChangePage(pagination) {
    console.log("aloalo");
    const { dispatch, location } = this.props;
    const currParams = queryString.parse(location.search.replace("?", ""));
    const paramsStr = queryString.stringify({
      ...currParams,
      page: pagination,
    });
    dispatch(push(`${location.pathname}?${paramsStr}`));
  }

  render() {
    const {
      meta,
      items,
      loading,
      total_revenue,
      total_NN_fee,
      total_other_fee,
      total_khang_luat_fee,
    } = this.state;
    const { onChangePage } = this.props;
    return (
      <>
        {total_revenue >= 0 ? (
          <div>
            Tổng số tiền thu: {`${numeral(total_revenue).format("0,0")} VND`}
          </div>
        ) : null}
        {total_NN_fee >= 0 ? (
          <div>
            LPNN: {`${numeral(total_NN_fee).format("0,0")} VND`}
          </div>
        ) : null}
        {total_other_fee >= 0 ? (
          <div>
            Phí khác: {`${numeral(total_other_fee).format("0,0")} VND`}
          </div>
        ) : null}
        {total_khang_luat_fee >= 0 ? (
          <div>
            Phí Khang Luật:{" "}
            {`${numeral(total_khang_luat_fee).format("0,0")} VND`}
          </div>
        ) : null}
        <AntdTable
          pagination={{
            current: meta.current_page,
            pageSize: meta.per_page,
            total: meta.total,
            onChange: onChangePage ? onChangePage : this._onChangePage,
            showTotal: (total) => `Tổng ${total}`,
          }}
          rowKey={"id"}
          {...this.props}
          dataSource={items}
          loading={loading}
        />
      </>
    );
  }
}

export default PaginatedTable;
